import { render } from "./addressCon.vue?vue&type=template&id=12100cc6"
import script from "./addressCon.vue?vue&type=script&lang=js"
export * from "./addressCon.vue?vue&type=script&lang=js"

import "./addressCon.vue?vue&type=style&index=0&id=12100cc6&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__